import styled, { css } from "styled-components";

export const BTTO_PROFILE_COLORS = {
	bg: "#0a0e1a",
	surface: "#171c2a",
	surfaceRaised: "#1f2536",
	surfaceHover: "#252b3d",
	border: "#2c313c",
	borderActive: "#0362d4",
	text: "#e5f0fe",
	textMuted: "#a5b1c1",
	textDim: "#7c85a1",
	primary: "var(--bt-auth-primary, #0362d4)",
	primaryDark: "#0251b0",
	primaryText: "#ffffff",
	warning: "#f97316",
	danger: "#ef4444",
	success: "#14c852",
};

export const BettoProfilePageRoot = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	min-height: 100%;
	gap: 16px;
	padding: 0 0 32px;

	@media (min-width: 768px) {
		gap: 20px;
		padding: 0 0 40px;
	}
`;

export const BettoPageTitle = styled.h1`
	margin: 0;
	color: ${BTTO_PROFILE_COLORS.text};
	font-size: 18px;
	font-weight: 700;
	line-height: 1.2;

	@media (min-width: 768px) {
		font-size: 20px;
	}
`;

export const BettoSettingsGrid = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	gap: 16px;
	width: 100%;

	@media (min-width: 1024px) {
		grid-template-columns: 220px minmax(0, 1fr);
		gap: 20px;
		align-items: start;
	}
`;

export const BettoContentColumn = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
	min-width: 0;
	width: 100%;
`;

export const BettoCardGrid = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	gap: 12px;

	@media (min-width: 640px) {
		grid-template-columns: repeat(2, minmax(0, 1fr));
	}

	@media (min-width: 1024px) {
		gap: 16px;
	}
`;

export const BettoDivider = styled.hr`
	width: 100%;
	margin: 0;
	border: none;
	border-top: 1px solid ${BTTO_PROFILE_COLORS.border};
`;

export const bettoFocusRing = css`
	&:focus-visible {
		outline: 2px solid ${BTTO_PROFILE_COLORS.borderActive};
		outline-offset: 2px;
	}
`;
